<template>
  <div class="c-flex-column">
    <div
      class="box1 c-flex1"
      @click="$router.push({ path: '/partner' })"
    >
      <img
        class="bj-img"
        src="@/assets/img/images/wallet1-bj.png"
        alt="wallet1-bj.png"
      />
      <img
        class="hot-img"
        src="@/assets/img/images/icon/wallet-hot.png"
        alt="wallet1-hot.png"
      />
      <p class="p1">
        {{ $t("user_assets.web_record.membershipPackage") }}
        <i class="el-icon-arrow-right"></i>
      </p>
      <p class="p2">
        {{ userAsset.dk || 0 }}
        <span>dk</span>
      </p>
    </div>
    <div class="box2 c-flex1 c-flex-column">
      <div class="input-box">
        <div class="title">{{ $t("user_assets.web_record.searchTitle") }}</div>
        <el-input
          style="width: 240px"
          :placeholder="$t('user_assets.search')"
          suffix-icon="el-icon-search"
          v-model="tableFilter.keyword"
          @keyup.enter.native="getFilterTableData"
        />
      </div>
      <el-table
        v-loading="loading"
        :data="filterTableData"
        style="width: 100%"
        header-cell-class-name="table-head"
        cell-class-name="table-cell"
      >
        <el-table-column
          prop="assetType"
          :label="$t('user_assets.coin_type')"
          sortable
          width="200"
        >
          <template slot-scope="scope">
            <div class="c-flex-left">
              <img
                v-if="scope.row.icon"
                class="coin-type"
                :src="scope.row.icon"
                style="width: 24px; margin-right: 4px"
              />
              <img
                v-else
                class="coin-type"
                src="@/assets/img/icon_coin_default.png"
                style="width: 24px; margin-right: 4px"
              />
              <strong v-if="scope.row.assetType === 'USDT'">{{ scope.row.assetType.replace("T", "") }}</strong>
              <strong v-else>{{ scope.row.assetType }}</strong>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('user_assets.available_balance')"
          width="220"
        >
          <template slot-scope="scope">
            {{ detailShow ? scope.row.balanceAvailable : "******" }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('user_assets.freeze_balance')" width="220">
          <template slot-scope="scope">
            <label>{{ detailShow ? scope.row.balanceFrozen : "******" }}</label>
            <span v-if="detailShow && scope.row.redeem > 0" class="redeem">
              ({{ $t("user_assets.redeem") }}:{{ scope.row.redeem }})
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="assetCurrency"
          :label="'HKD' + $t('user_assets.valuations')"
          sortable
        >
          <template slot-scope="scope">
            <template v-if="detailShow">
              <!-- {{ scope.row.assetBTC }} -->
              <label class="cny-value">
                &#8776;
                {{ scope.row.assetCurrency }}
                {{ scope.row.currency }}
              </label>
            </template>
            <template v-else> ****** </template>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('user_assets.web_record.operation')"
          width="100"
        >
          <template slot-scope="{ row }">
            <el-popover
              placement="bottom"
              trigger="hover"
              popper-class="popper-more-btn"
              @show="popoverShow(row.id)"
              @hide="popoverHide(row.id)"
            >
              <div class="more-btn">
				<div @click="dropdownClick(3, row)">
				  {{ $t("user_assets.web_record.recharge2") }}
				</div>
				<div @click="dropdownClick(4, row)">
				  {{ $t("user_assets.web_record.withdraw") }}
				</div>
				<div @click="dropdownClick(5, row)">
				  {{ $t("user_assets.web_record.title") }}
				</div>
              </div>
              <div
                class="more-icon"
                slot="reference"
                :style="{
                  background:
                    popoverVisible && currId == row.id ? '#4063ff' : '#eaebed',
                }"
              >
                <img
                  :src="
                    popoverVisible && currId == row.id
                      ? require('@/assets/img/images/icon/more-s-icon.png')
                      : require('@/assets/img/images/icon/more-icon.png')
                  "
                />
              </div>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <ChargingDialog v-if="currId" ref="chargingDialogRef" />
    <WithdrawDialog v-if="currId" ref="withdrawDialogRef" />
	<MarketLogDialog ref="marketLogDialogRef" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ChargingDialog from "./ChargingDialog";
import WithdrawDialog from "./WithdrawDialog";
import MarketLogDialog from "./MarketLogDialog";
export default {
  components: {
    ChargingDialog,
    WithdrawDialog,
	MarketLogDialog
  },
  data() {
    return {
      loading: false,
      detailShow: true,
      tableFilter: {
        littleAssetHide: false,
        keyword: "",
      },
      inputValue: "",
      currId: null,
      popoverVisible: false,
      tableData: [],
      filterTableData: [],
      userAsset: {
        dk: "",
        currency: "",
        totalAssetBTC: "",
        totalAssetCurrency: "",
      },
    };
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
  },
  created() {
    this.getUserAsset();
    this.getUserAssetList();
  },
  methods: {
    //获取用户资产
    getUserAsset() {
      this.$axios
        .post("/userAssets/queryAssetList", {
          assetType: "pay-card",
		  legalCurrency: "USD",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.userAsset = res.data.data;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    //获取用户资产
    getUserAssetList() {
      this.loading = true;
      this.$axios
        .post("/userAssets/queryAssetList", {
          assetType: "USDT",
		  legalCurrency: "HKD",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.userAssets = res.data.data;
            this.tableData = res.data.data.userAssetRsps;
            this.getFilterTableData();
          } else {
            this.loading = false;
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    getFilterTableData() {
      this.filterTableData = [];
      this.tableData.forEach((value, index) => {
        value.id = index + 1;
        if (this.tableFilter.keyword) {
          if (
            value.assetType
              .toUpperCase()
              .indexOf(this.tableFilter.keyword.toUpperCase()) >= 0
          ) {
            if (this.tableFilter.littleAssetHide) {
              //隐藏小额资产
              if (value.assetCurrency >= 1) {
                this.filterTableData.push(value);
              }
            } else {
              this.filterTableData.push(value);
            }
          }
        } else {
          if (this.tableFilter.littleAssetHide) {
            //隐藏小额资产
            if (value.assetCurrency >= 1) {
              this.filterTableData.push(value);
            }
          } else {
            this.filterTableData.push(value);
          }
        }
      });
      this.loading = false;
    },
    popoverShow(val) {
      this.currId = val;
      this.popoverVisible = true;
    },
    popoverHide(val) {
      this.currId = val;
      this.popoverVisible = false;
    },
    dropdownClick(val, row) {
      switch (val) {
        case 3:
          this.addCoins(row);
          break;
        case 4:
          this.withdrawCoins(row);
          break;
        case 5:
          this.$refs.marketLogDialogRef.dialogVisible = true;
          break;
      }
    },
    // 充值
    addCoins(row) {
      if (row.canRecharge === -1) {
        //禁止充值
        this.$message({
          type: "error",
          message: this.$t("user_assets.can_not_recharge"),
        });
        return false;
      }
      this.$refs.chargingDialogRef.init(row);
    },
    // 提币
    withdrawCoins(row) {
      // 禁止提币
      if (row.canWithdraw === -1) {
        this.$message({
          type: "error",
          message: this.$t("user_assets.can_not_withdraw"),
        });
        return false;
      }
      // 是否开启至少2个以上的验证
      if (!this.judgeValidateNum()) {
        return false;
      }      // 是否未进行身份认证
      if (this.user.statusKycLevel !== 1) {
        this.$message({
          type: "error",
          message: this.$t("tipsVal.userAuthenticate"),
        });
        return false;
      }
      // 是否设置交易密码
      if (this.user.tranPassword === -1) {
        this.$confirm(
          this.$t("partner.need_set_password"),
          this.$t("user_center.tip"),
          {
            confirmButtonText: this.$t("partner.set_now"),
            cancelButtonText: this.$t("partner.cancel"),
            type: "warning",
          },
        )
          .then(() => {
            this.$router.push({ path: "/user" });
          })
          .catch(() => {});
      } else {
        this.$refs.withdrawDialogRef.init(row);
      }
      // this.$refs.withdrawDialogRef.init(row);
    },
    //是否开启了2种及以上的验证
    judgeValidateNum() {
      let sum = 0;
      if (this.user.phoneSecurity === 1) {
        sum++;
      }
      if (this.user.emailSecurity === 1) {
        sum++;
      }
      if (this.user.googleSecurity === 1) {
        sum++;
      }
      if (sum >= 2) {
        return true;
      } else {
        this.$message({
          type: "warning",
          message: this.$t("user_assets.validate_warning"),
        });
        return false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.more-btn {
  text-align: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #1a1a1a;
  div {
    cursor: pointer;
    margin-top: 12px;
  }
  div:first-child {
    margin-top: 0px;
  }
}
.box1 {
  cursor: pointer;
  padding: 32px 40px;
  position: relative;
  background: #ffffff;
  border-radius: 14px 14px 14px 14px;
  .p1 {
    left: 60px;
    top: 50px;
    position: absolute;
    display: flex;
    align-items: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    i {
      color: #4063ff;
      font-size: 12px;
      margin-left: 4px;
    }
  }
  .p2 {
    left: 60px;
    top: 80px;
    position: absolute;
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 35px;
    color: #4063ff;
    span {
      font-weight: 400;
      font-size: 20px;
    }
  }
  .bj-img {
    width: 100%;
    height: 120px;
  }
  .hot-img {
    width: 48px;
    height: 48px;
    right: 40px;
    top: 32px;
    position: absolute;
  }
}
.box2 {
  padding: 40px;
  margin-top: 16px;
  background: #ffffff;
  border-radius: 14px 14px 14px 14px;
  /deep/.table-head {
    background: rgba(234, 235, 237, 0.5);
  }
  /deep/.table-head:first-child {
    border-radius: 6px 0px 0px 6px;
  }
  /deep/.table-head:last-child {
    border-radius: 0px 6px 6px 0px;
  }
  /deep/.table-cell {
    border: none;
  }
  /deep/ .el-table__body tr.current-row > td {
    background-color: rgba(225, 234, 255, 0.6) !important;
  }
  /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(225, 234, 255, 0.6) !important;
  }
  .coin-img {
    width: 28px;
    height: 28px;
    margin-right: 14px;
  }
  .btn-box {
    gap: 8px;
    display: flex;
  }

  .more-icon {
    width: 52px;
    height: 32px;
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    background: #eaebed;
    border-radius: 4px 4px 4px 4px;
    img {
      width: 20px;
      height: 4px;
    }
  }

  .btn {
    width: 52px;
    height: 32px;
    padding: 0px;
    border: none;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    border-radius: 4px 4px 4px 4px;
  }
  .btn-color1 {
    color: #333333;
    background: #d6d8db;
  }
  .btn-color2 {
    color: #ffffff;
    background: #f04545;
  }
  .btn-color3 {
    color: #ffffff;
    background: #52c18e;
  }
  .btn-color4 {
    color: #ffffff;
    background: #4063ff;
  }
  .btn-color5 {
    color: #ffffff;
    background: #ffc765;
  }
  .input-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 18px;
    color: #333333;
    padding-bottom: 10px;
    margin-bottom: 20px;
    position: relative;
    border-bottom: 1px solid #e2e3e3;
    .title::before {
      content: "";
      position: absolute;
      display: block;
      left: 0;
      width: 36px;
      bottom: 0;
      border-bottom: 2px solid #4063ff;
    }
  }
}
</style>
